var avatars = require('sma.applicant/detail/partials/avatars.mustache');

class CollaboratorAvatars {

	constructor(applicationId) {

		this.applicationId = applicationId;

		// Before builing the modal lets see if we have any collaborators
		this.getCollaborators();
	}

	renderAvatars(collaborators) {
		var renderedAvatars = [];
		$.each(collaborators, (i, el) => {
			var rendered = avatars(el);
			renderedAvatars.push(rendered);
 		});

		$(".collaborator-avatars").empty();
		$(".collaborator-avatars").append(renderedAvatars);
	}

	/**
	 * GET all collaborators on the application
	 */
	getCollaborators() {
		var collaborators = [];

		sma.applicants.components.ajax.get({
			url: reverse('get-collaborators', {
				app_id: this.applicationId,
			}),
			data: {
				includeOwner: true,
			},
			callback: $.proxy(function(collaborators) {
				// Build the rows with the newly retrieved collaborators
				this.renderAvatars(collaborators);
			}, this)
		});
	}
}

module.exports = {
	"CollaboratorAvatars": CollaboratorAvatars
}
